export default {
    ar: "العربية",
    en: "English",
    qatar:"قطر",
    statuses: {
        undefined: "غير مكتمل",
        Unfinished: "غير مكتمل",
        Pending: "قيد الإنتظار",
        Accepted: "تم القبول",
        Checking: "قيد الفحص",
        Chacking: "قيد الفحص",
        EndCheck: "قيد الفحص",
        Auditing: "قيد الفحص",
        Done: "مكتمل",
    },
    form: {
        level1: "هيكل عام",
        level2: "خصائص",
        level3: "تفاصيل دقيقة",
    },
    click_to_see_more: "إضغط لعرض المزيد",
    create_new_project: "إنشاء مشروع جديد",
    customer_data: "بيانات المستفيد",
    user_info: "معلومات المستخدم",
    structure_unit_data: "تفاصيل الوحدة العقارية",
    checking_data: "تفاصيل الفحص",
    order_summary: "ملخص الطلب",
    pay_cache: "هل ستقوم بالدفع نقداً (سيتم التواصل معك من قبل الفاحص وستكون حالة المشروع قيد الانتظار)",
    next: "التالي",
    add_new: "إضافة جديد",
    update_project: "تعديل المشروع",
    yes: "اوافق",
    no: "غير موافق",
    payment: "الدفع",
    cash: "كاش",
    prev: "السابق",
    email_sent: "تم ارسال بريد الاسترداد لكلمة السر الى البريد الذي أدخلته بنجاح",
    count: "العدد",
    readmore: "قراءة المزيد",
    add_other: "إضافة أخر",
    home: "الرئيسية",
    project_form: "استمارة المشروع",
    appearance: "المظهر",
    close_form: "إغلاق الاستمارة",
    performance: "الأداء",
    images: "صور",
    project_document: "وثائق المشروع",
    close: "إغلاق",
    send_docs: "حفظ الملفات",
    filename: "اسم الملف",
    sent_success: "تم الإرسال بنجاح",
    property_project_completed_successfully: "تم حفظ المعلومات بنجاح",
    add_values: "إضافة معلومات",
    already_project_form_submitted: "تم ادخال بيانات المشروع بالفعل",
    add_more: "إضافة المزيد",
    checker_dashboard: "لوحة التحكم",
    dont_have_permission: "ليس لديك الصلاحيات للوصول الى هذه الصفحة",
    name: "الاسم",
    back: "رجوع",
    report: "التقرير",
    rate: "تقييم",
    zone_no: "رقم المنطقة",
    street_number: "رقم الشارع",
    payment_info: "معلومات الدفع",
    order_number: "رقم الطلب",
    check_data: "وقت الفحص",
    checker_name: "اسم  المهندس الفاحص",
    project_status: "حالة المشروع",
    rate_service: "تقييم الخدمة",
    order_details: "تفاصيل الطلب",
    service_type: "نوع الخدمة",
    the_message: "الرسالة",
    check_date: "تاريخ الفحص",
    basic_ayan: "موثوق اساسي",
    preferred_date: "التاريخ المفضل",
    preferred_time: "الوقت المفضل",
    preferred_time_hour: "الساعة المناسبة لك للفحص",
    preferred_time_minutes: "الدقيقة",
    confirm: "تأكيد",
    period: "الفترة",
    hello: "مرحباً ",
    choose_custom_checker: "اختيار  مهندس فاحص محدد",
    create_new_order: "إنشاء طلب جديد",
    orders: "الطلبات",
    notes: "ملاحظات",
    building_no: "رقم البناء",
    unit_no: "رقم الوحدة",
    title: "العنوان",
    choose_answer: "إختر اجابة",
    building_area: "مساحة السطح (متر مربع)",
    open_date: "وقت مفتوح",
    building_type: "نوع العقار",
    building_details: "تفاصيل العقار",
    other_select: "اختيار أخر",
    street_no: "رقم الشارع",
    send: "إرسال",
    my_profile: "حسابي",
    not_exist: "غير موجود ",
    project_completed_successfully:
        "تم حفظ المشروع بنجاح يرجى التحقق من البريد الالكتروني",
    my_projects: "مشاريعي",
    total: "المجموع الاجمالي",
    vat: "ضريبة القيمة المضافة",
    total_cost: "مجموع الطلب",
    currency: "ريال قطري",
    unit: "م2",
    check_date_and_period: "التاريخ والفترة",
    services: "الخدمات",
    subject: "الموضوع",
    forget_password: "هل نسيت كلمة السر؟",
    reset_password: "نسيت كلمة السّر؟",
    reset_password_body: "لا تقلق! أرسل لنا بريدك الإلكتروني و سيتم إرسال رابط إعادة تعيين كلمة السّر على الفور",
    register_new: "تسجيل حساب جديد",
    first_name: "الاسم الاول",
    last_name: "الاسم الاخير",
    password: "كلمة السر",
    phone: "رقم الهاتف",
    full_name: "الاسم",
    phone_number: "رقم الهاتف",
    email: "البريد الالكتروني",
    site_type: "نوع العقار",
    location: "الموقع",
    explore_website: "تصفح الموقع",
    about: "عن موثوق",
    price_offer: "عرض السعر",
    tslam: "مقبل على شراء بيت العمر؟ #موثوق_تسلم",
    calculate_check_cost: "حساب تكلفة الفحص",
    common_question: "الأسئلة الشائعة",
    blog: "المدونة",
    contact: "تواصل",
    main_check_items: "عناصر الفحص الرئيسية",
    homeReviewsTitle: "آراء عملائنا",
    eleictric: "الكهرباء",
    eleictric_text: "فحص الأفياش، ووحدات الإنارة، وطبلون الكهرباء.",
    plumbing: "سباكة",
    plumning_text: `
  فحص ميول الأرضيات، الأدوات الصحية، صفايات الماء، مواسير السباكة الظاهرة، سخان
              الماء، خزان الماء، مضخة الماء.
  `,
    walls: "الجدران",
    walls_text: `فحص الدهانات، آثار التسريب، الشقوق والتصدعات، سيراميك الجدران، كورنيش
  الجدران.`,
    doors: "الأبواب",
    doors_text: `
  فحص نوعية كل باب، الصدأ والاهتراء، جودة الإطار، سلاسة الفتح والإغلاق،
              المقابض، المفصلات، الأقفال، المصدات، وزنية الباب.
  `,
    windows: "النواف",
    windows_text: `فحص نوعية الزجاج، الإطار، العزل، سلاسة الفتح والإغلاق، المجرى، الأقفال، قضبان
  الحماية، شبك الحشرات.`,

    eng: "المهندس",
    project_details: "تفاصيل المشروع",
    project_image: "صورة المشروع",
    "building_status": "حالة البناء",
    "entry_number": "رقم الادخال",
    "contract_number": "مدير البناء",
    "owner": "المالك",
    "artitacture_developer": "المعماري",
    "office_design": "مكتب التصميم",
    "supervisor_eng": "المهندس المشرف",
    "main_provider": "المالك الرئيسي",
    "electri_counter1": "عداد كهرباء 1",
    "electri_counter2": "عدادا كهرباء 2",
    "electri_counter_reed1": "قراءة عداد كهرباء 1",
    "electri_counter_reed2": "قراءة عداد كهرباء 2",
    "water_counter": "عداد المياه",
    "water_counter_reed": " قراءة عداد المياه",
    "property_age": "عمر البناء",
    "ground_space": "مساحة الارضية",
    "building_spaces": "مساحة البناء",
    "floors": "عدد الطوابق",
    project_infrastructure: 'البنية التحتية',
    project_feature: 'الميزات',
    project_notes: 'أبرز الملاحظات',
    grands: "الأرضيات",
    proierty: 'الاهمية',
    note: 'الملاحظات',
    recomend: 'التوصيات',
    grands_text: `فحص تشطيب الارضيات، التطبيل، الترويب، النعلات، العتبة، فواصل التمدد`,
    roofs: "الأسقف",
    no_orders: "لا يوجد طلبات",
    roofs_text: "فحص الدهانات، الديكورات، الشقوق والتصدعات، فتحات الصيانة.",
    conditioning: "التكييف والتهوية",
    conditioning_text: "فحص مراوح الشفط، وحدات التكييف، تأسيسات التكييف وفتحات التكييف.",
    register_as_checker: "تسجيل جديد كمهندس فاحص",
    register_as_checker_note: "هذه الصفحة خاصة للمهندسين الراغبين بالانضمام لفريق موثوق الفني",
    login: "تسجيل الدخول",
    no_data: "لا يوجد بيانات",
    request_service: "طلب خدمة",
    what_we_offer: "ماذا نقدم في موثوق؟",
    what_we_offer_text: `
    نسعى في موثوق إلى تبسيط عملية فحص العقارات
                لمساعدة المشتري على اتخاذ قرار مبني على معلومة واضحة قبل الشراء.
    `,
    contact_and_question: "للتواصل والاستفسار",
    payment_methods: "وسائل دفع آمنة",
    policy_1: "جميع الحقوق محفوظة لمنصة موثوق © 2019-2021",
    policy_2: "اتفاقية الاستخدام",
    policy_3: "سياسة الخصوصية",
    policy_4: "سياسة الإلغاء والاسترداد",
    vision: "رؤيتنا",
    message: "رسالتنا",
    follow_us: "تابعنا",
    my_account: "حسابي",
    register_user: "تسجيل جديد كمستخدم",
    register_check: "تسجيل جديد كمهندس فاحص",
    register: "تسجيل حساب جديد",
    logout: "تسجيل الخروج",
    request_new_form: "طلب تعبئة استمارة لهذا المشروع",
    newest_articles: "أحدث المقالات",
    register_email: `                                              يرجى إدخال البريد الإلكتروني الخاص بك، وسيتم إرسال
                                              رسالة للتحقق من البريد الإلكتروني.`,
    footer: {
        whatsapp: "واتس اب",
        email: "بريد إلكتروني",
    },
    about_texts: {
        text1: ` عاين هي منصة إلكترونية تمكنك من طلب خدمة فحص العقارات بسهولة والحصول على تقرير فحص
                                احترافي بمؤشرات سهلة القراءة بواسطة فاحصين مؤهلين. تأسست عاين في شهر سبتمبر 2017 وبدأت
                                مشوارها كمقدم لخدمة الفحص. ولكن نظرًا لحجم الطلب المتزايد قرر المؤسسون تحويلها إلى منصة
                                تقدم خدمة الفحص من خلال فاحصين مستقلين ومكاتب فحص متخصصة ذات خبرة وكفاءة، وذلك في شهر
                                أغسطس 2018.`,
        text2: `                              منصة عاين مملوكة بالكامل لشركة منصة عاين المحدودة، وهي شركة سعودية تحمل سجل تجاري رقم
                                2051226297 ومقرها مدينة الدمام في المملكة العربية السعودية.`,
        text3: `                              نسعى في عاين إلى تبسيط عملية فحص العقارات لمساعدة المشتري على اتخاذ قرار مبني على معلومة
                                واضحة قبل الشراء.&nbsp;ولتحقيق ذلك قمنا بتصميم مصفوفة معايير فحص متخصصة ضمن نماذج مستقاة
                                من أفضل الممارسات العالمية في هذا المجال، ثم دمجنا قوة المعرفة بسهولة التقنية لتنتج خدمة
                                سهلة الاستخدام وذات كفاءة عالية.`,
        text4: `أن نجعل جميع التعاملات العقارية شفافة وموثوقة.`,
        text5: `                              أن نساعد عملاءنا على اتخاذ قرارات عقارية مبنية على بينة من خلال تمكين المحترفين من جمع،
                                ومعالجة، وتصوير البيانات بواسطة تقنيات مبتكرة.`,

    },
};


// fetch("http://backend.mawthuq.com/api/ownershipproperty/store", {
//   "headers": {
//     "accept": "application/json, text/plain, */*",
//     "accept-language": "en-US,en;q=0.9,ar;q=0.8",
//     "authorization": "Bearer 494|eV6FCvVYb0iWWDdrxFYCMDgthWquBvVFRfMoS78E",
//     "cache-control": "no-cache",
//     "content-type": "application/json",
//     "pragma": "no-cache"
//   },
//   "referrer": "http://localhost:8080/",
//   "referrerPolicy": "strict-origin-when-cross-origin",
//   "body": "{\"project_id\":\"8\",\"items\":[{\"id\":244,\"name\":\"طابق\",\"index\":\"1\",\"chiled\":[{\"id\":249,\"name\":\"صالة\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":3,\"name\":\"كهرباء\",\"count\":1},{\"ownership_property_id\":5,\"name\":\"الأرضيات\",\"count\":1},{\"ownership_property_id\":6,\"name\":\"الجدران\",\"count\":1},{\"ownership_property_id\":7,\"name\":\"الأسقف\",\"count\":1},{\"ownership_property_id\":8,\"name\":\"التكييف والتهوية\",\"count\":1}]},{\"id\":250,\"name\":\"دورة مياه\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":10,\"name\":\"كهرباء\",\"count\":1},{\"ownership_property_id\":45,\"name\":\"تجهيزات صحية\",\"count\":1},{\"ownership_property_id\":55,\"name\":\"اسقف\",\"count\":1},{\"ownership_property_id\":179,\"name\":\"التكييف والتهوية\",\"count\":1}]},{\"id\":251,\"name\":\"غرفة نوم\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":56,\"name\":\"اسقف\",\"count\":1},{\"ownership_property_id\":180,\"name\":\"جدران\",\"count\":1}]},{\"id\":252,\"name\":\"غرفة جلوس\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":57,\"name\":\"نوافذ\",\"count\":1}]}]},{\"id\":245,\"name\":\"ملحق\",\"index\":\"1\",\"chiled\":[{\"id\":253,\"name\":\"بلكون\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":48,\"name\":\"سباكة\",\"count\":1}]},{\"id\":254,\"name\":\"نوم\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":395,\"name\":\"الكهرباء\",\"count\":1},{\"ownership_property_id\":396,\"name\":\"الأرضيات\",\"count\":1},{\"ownership_property_id\":397,\"name\":\"الجدران\",\"count\":0},{\"ownership_property_id\":398,\"name\":\"الأبواب\",\"count\":0},{\"ownership_property_id\":399,\"name\":\"النوافذ\",\"count\":0},{\"ownership_property_id\":400,\"name\":\"الأسقف\",\"count\":0},{\"ownership_property_id\":401,\"name\":\"التكييف والتهوية\",\"count\":0},{\"ownership_property_id\":402,\"name\":\"السباكة\",\"count\":1}]}]},{\"id\":246,\"name\":\"ارضي\",\"index\":\"1\",\"chiled\":[{\"id\":255,\"name\":\"مسبح\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":51,\"name\":\"ارضية\",\"count\":0}]}]},{\"id\":247,\"name\":\"حوش\",\"index\":\"1\",\"chiled\":[{\"id\":256,\"name\":\"سور\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":404,\"name\":\"الكهرباء\",\"count\":1},{\"ownership_property_id\":405,\"name\":\"الأرضيات\",\"count\":1},{\"ownership_property_id\":406,\"name\":\"الجدران\",\"count\":1},{\"ownership_property_id\":407,\"name\":\"الأبواب\",\"count\":0},{\"ownership_property_id\":408,\"name\":\"النوافذ\",\"count\":0},{\"ownership_property_id\":409,\"name\":\"الأسقف\",\"count\":0},{\"ownership_property_id\":410,\"name\":\"التكييف والتهوية\",\"count\":0},{\"ownership_property_id\":411,\"name\":\"السباكة\",\"count\":0}]}]},{\"id\":248,\"name\":\"مكرر\",\"index\":\"1\",\"chiled\":[{\"id\":257,\"name\":\"غرقة نوم\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":414,\"name\":\"الكهرباء\",\"count\":0},{\"ownership_property_id\":415,\"name\":\"الأرضيات\",\"count\":1},{\"ownership_property_id\":416,\"name\":\"الجدران\",\"count\":0},{\"ownership_property_id\":417,\"name\":\"الأبواب\",\"count\":0},{\"ownership_property_id\":418,\"name\":\"النوافذ\",\"count\":0},{\"ownership_property_id\":419,\"name\":\"الأسقف\",\"count\":0},{\"ownership_property_id\":420,\"name\":\"التكييف والتهوية\",\"count\":0},{\"ownership_property_id\":421,\"name\":\"السباكة\",\"count\":1}]},{\"id\":258,\"name\":\"غرفة نوم\",\"index\":\"1\",\"chiled\":[{\"ownership_property_id\":423,\"name\":\"الكهرباء\",\"count\":0},{\"ownership_property_id\":424,\"name\":\"الأرضيات\",\"count\":0},{\"ownership_property_id\":425,\"name\":\"الجدران\",\"count\":0},{\"ownership_property_id\":426,\"name\":\"الأبواب\",\"count\":0},{\"ownership_property_id\":427,\"name\":\"النوافذ\",\"count\":1},{\"ownership_property_id\":428,\"name\":\"الأسقف\",\"count\":0},{\"ownership_property_id\":429,\"name\":\"التكييف والتهوية\",\"count\":0},{\"ownership_property_id\":430,\"name\":\"السباكة\",\"count\":0}]}]}]}",
//   "method": "POST",
//   "mode": "cors",
//   "credentials": "include"
// });
